import Button from "@app/components/button";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import { addToast } from "@app/components/toast/toast.service";
import { SystemMessage } from "@app/constants";
import UserService from "@app/services/http/user.service";
import { Form, Formik } from "formik";
import { useParams } from "react-router-dom";
import { useState } from "react";

const VasTab = () => {
  const { userId } = useParams();
  const [title, setTitle] = useState("Tăng/Giảm vas");

  const handleSubmit = async (values: { point: number | string, note: string }) => {
    await UserService.updatePointUser(Number(userId), values.point, values.note);

    addToast({ text: SystemMessage.UPDATE_SUCCESSFULLY });
  };

  const handleTitleChange = (value: number | string) => {
    const pointValue = Number(value);

    if (pointValue > 0) {
      setTitle("Tăng vas");
    } else if (pointValue < 0) {
      setTitle("Giảm vas");
    } else {
      setTitle("Tăng/Giảm vas");
    }
  };

  return (
    <div className="flex gap-32">
      <div>
        <Formik
          initialValues={{
            point: "0",
            note: "",
          }}
          onSubmit={handleSubmit}
          validateOnBlur
          validateOnChange
          enableReinitialize
        >
          {({ resetForm, values, handleChange }) => (
            <Form>
              <div>
                <div className="text-sm mt-4">{title}</div>
                <FormControl name="point">
                  <Input
                    className="mt-1 !w-[375px]"
                    placeholder="Vas"
                    inputClassName="!bg-[rgba(239,241,249,0.60)] !rounded-xl font-medium !h-[52px] !leading-[52px]"
                    type="number"
                    value={values.point}
                    onChange={(e) => {
                      handleChange(e);
                      handleTitleChange(e.target.value);
                    }}
                  />
                </FormControl>
              </div>

              <div>
                <div className="text-sm mt-4">Ghi chú</div>
                <FormControl name="note">
                  <Input
                    className="mt-1 !w-[375px]"
                    placeholder="Nhập ghi chú"
                    inputClassName="!bg-[rgba(239,241,249,0.60)] !rounded-xl font-medium !h-[52px] !leading-[52px]"
                    type="text"
                    value={values.note}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </FormControl>
              </div>

              <div className="flex">
                <Button
                  containerClassName="mt-[20px]"
                  width="auto"
                  type="submit"
                  className="!w-[118px] !h-[52px] font-medium !rounded-xl"
                  label="Cập nhật"
                />
                <Button
                  containerClassName="mt-[20px] ml-6"
                  width="auto"
                  className="!w-[118px] !h-[52px] font-medium !rounded-xl"
                  label="Hủy"
                  theme="secondary"
                  onClick={() => resetForm()}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default VasTab;
